import React from 'react'
import PropTypes from 'prop-types'

// Components
import Box from 'ui/Box'
import Text from 'ui/Text'
import Button from 'ui/Button'
import IconQuestion from 'ui/Icons/IconQuestion'

export const NeedHelp = ({ title, onOpenPopup, content, textButton }) => {
  const onOpen = () => {
    onOpenPopup()
  }

  return (
    <Box style={{ borderRadius: 0 }}>
      <IconQuestion width="90px" height="90px" />
      <div style={{ marginLeft: '15px' }}>
        <Text size={16} bold color="#222222">
          {title}
        </Text>
        <Text size={16} color="#070707">
          {content}
        </Text>
        <Button variant="link" underline onClick={onOpen}>
          {textButton}
        </Button>
      </div>
    </Box>
  )
}

NeedHelp.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  textButton: PropTypes.string,
  onOpenPopup: PropTypes.func,
}
NeedHelp.defaultProps = {
  title: 'Need help?',
  content: '',
  textButton: '',
  onOpenPopup: () => {},
}

export default NeedHelp
